export default "__VITE_ASSET__CFRj7cNF__"